export const localState = [
  {
    id: 1,
    delay: 1000,
    tokenomics_number: 72,
  },
  {
    id: 2,
    delay: 2000,
    tokenomics_number: 10,
  },
  {
    id: 3,
    delay: 3000,

    tokenomics_number: 9,
  },
  {
    id: 4,
    delay: 4000,
    tokenomics_number: 4,
  },
  {
    id: 5,
    delay: 5000,
    tokenomics_number: 4,
  },
  {
    id: 6,
    delay: 6000,
    tokenomics_number: 1,
  },
];
